import { matchPath } from 'react-router';
import { createRoute } from './createRoute';
import { generatePath } from './generatePath';

export interface SubCategoryPageParams {
  page: number;
  categorySlug: string;
  subCategorySlug: string;
}

export interface SubCategory {
  routeName: 'subCategory';
  params: SubCategoryPageParams;
}

export const subCategoryRoute = createRoute<SubCategoryPageParams, 'categorySlug' | 'subCategorySlug'>({
  pattern: '/html/:categorySlug/:subCategorySlug/:page?',
  match: (pattern, location): SubCategoryPageParams => {
    const { pathname } = location;
    const match = matchPath({ path: pattern }, pathname);

    if (!match) {
      return null;
    }

    const pageNumber = Number(match.params.page);

    return {
      categorySlug: decodeURIComponent(match.params.categorySlug ?? ''),
      subCategorySlug: decodeURIComponent(match.params.subCategorySlug ?? ''),
      page: pageNumber > 1 ? pageNumber : 1,
    };
  },
  build: (pattern, params) => {
    const { page, categorySlug, subCategorySlug } = params;
    const pathParams = {
      page: page == null || page === 1 ? null : String(page),
      categorySlug: (categorySlug || '').toLowerCase(),
      subCategorySlug: (subCategorySlug || '').toLowerCase(),
    };

    return { pathname: generatePath(pattern, pathParams), search: '' };
  },
});
